module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"display_by_product":"按產品評價","search_placeholder":"評論關鍵字搜尋"}}')
  delete Component.options._Ctor
}
